/* eslint-disable import/prefer-default-export */
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import appReducer from '../reducers';

const middleware = [thunk];
export const store = createStore(appReducer, applyMiddleware(...middleware));



// WEBPACK FOOTER //
// ./src/helpers/store.js